// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1KiaE","label":"Labeled_label__1B73Q","divider":"Labeled_divider__2QR42"};